var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card-content",
    [
      _c("w-textarea", {
        attrs: { fancy: "", label: _vm.$ct("labels.reason") },
        model: {
          value: _vm.event.Props.Message,
          callback: function ($$v) {
            _vm.$set(_vm.event.Props, "Message", $$v)
          },
          expression: "event.Props.Message",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }